import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import hackathon from "../../../assets/images/hackathon.png";

const newsDetails = [
  {
    title:
      "Not Lagos. Not Abuja. Ogbomosho: Where Real Solutions Were Born at OORC Ideation 2026",
    subtitle:
      "Innovation isn’t just for tech hubs and big cities. The OORC Ideation 2026 proved that Ogbomosho has its own powerhouse of talent ready to solve local challenges. This two-day hackathon, held on May 29-30 at the OORC Innovation Hub, brought together students...",
    date: "June 10, 2026",
    author: "OORC Coordinator",
    pics: hackathon,
    links: "/2026-06-10/ogbomosho-where-real-solutions-were-born",
  },
];

const Blog = () => {
  return (
    <Grid container padding={{ xs: "2% 0% 20% 0%", sm: "2% 0% 10% 0%" }}>
      <Box
        width={{ xs: "100%", sm: "40%" }}
        marginLeft={{ xs: "0%", sm: "0%" }}
      >
        <Typography
          variant={"h3"}
          fontWeight={900}
          textAlign={"left"}
          color={"#071783"}
          paddingBottom={"1%"}
        >
          Our Blog
        </Typography>
      </Box>
      <Grid
        item
        xs={12}
        md={12}
        display={"flex"}
        justifyContent={"space-between"}
        flexWrap={"wrap"}
      >
        {newsDetails.map((details, index) => {
          const { pics, title, subtitle, date, author, links } = details;
          return (
            <Grid
              item
              key={index}
              xs={12}
              md={4}
              marginTop={{ xs: "10%", sm: "3%" }}
            >
              <Card sx={{ maxWidth: 380 }}>
                <CardActionArea href={links}>
                  <CardMedia
                    component="img"
                    height={"250vh"}
                    image={pics}
                    alt="blog_img"
                  />
                  <CardContent>
                    <Typography
                      fontWeight={500}
                      variant="body2"
                      color={"#aaa"}
                      paddingBottom={"4%"}
                    >
                      {date}
                    </Typography>
                    <Typography
                      gutterBottom
                      fontWeight={900}
                      variant="h5"
                      component="div"
                      paddingBottom={"2%"}
                      color="#071783"
                    >
                      {title}
                    </Typography>
                    <Typography
                      gutterBottom
                      fontWeight={400}
                      variant="body1"
                      paddingBottom={"4%"}
                      color="#000"
                    >
                      {subtitle}
                    </Typography>
                    <Typography fontWeight={500} variant="body2" color={"#aaa"}>
                      {author}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default Blog;
